// pdf.js from the bundle (pdfjs-dist, legacy build for older iPad Safari), loaded only when a PDF is read - no CDN request
// (legal-app / final-fix: no third-party script host). The worker is its own bundled chunk (webpack 5 new Worker(new URL(...))).
let _p = null
export function loadPdfjs() {
  if (_p) return _p
  _p = import('pdfjs-dist/legacy/build/pdf.mjs').then(pdfjs => {
    if (!pdfjs.GlobalWorkerOptions.workerPort) {
      pdfjs.GlobalWorkerOptions.workerPort = new Worker(new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url))
    }
    return pdfjs
  }).catch(e => { _p = null; throw e })
  return _p
}

// Render every page of a PDF to PNG Files.
export async function pdfToImages(file, maxEdge = 2400) {
  const pdfjs = await loadPdfjs()
  const buf = await file.arrayBuffer()
  const pdf = await pdfjs.getDocument({ data: buf }).promise
  const base = file.name.replace(/\.pdf$/i, '')
  const out = []
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)
    const v1 = page.getViewport({ scale: 1 })
    const scale = Math.min(4, maxEdge / Math.max(v1.width, v1.height))
    const vp = page.getViewport({ scale })
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(vp.width); canvas.height = Math.round(vp.height)
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height)
    await page.render({ canvas, canvasContext: ctx, viewport: vp }).promise
    const blob = await new Promise(r => canvas.toBlob(r, 'image/png'))
    const name = pdf.numPages > 1 ? `${base} p${i}` : base
    out.push(new File([blob], name + '.png', { type: 'image/png' }))
  }
  return out
}
